import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Menu',
    href: '#menu'
  }, {
    name: 'Atmosphere',
    href: '#atmosphere'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-black/90 backdrop-blur-md py-4 border-b border-brand-gold/10' : 'bg-transparent py-6'}`} data-id="element-114">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-center items-center relative" data-id="element-115">
        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-116">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm tracking-widest uppercase text-brand-offwhite/70 hover:text-brand-gold transition-colors duration-300" data-id="element-117">
              {link.name}
            </a>)}
          <a href="#contact" className="px-6 py-2 border border-brand-gold text-brand-gold text-sm tracking-widest uppercase hover:bg-brand-gold hover:text-brand-black transition-colors duration-300" data-id="element-118">
            Reservations
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-brand-offwhite" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-119">
          {isMobileMenuOpen ? <X size={24} data-id="element-120" /> : <Menu size={24} data-id="element-121" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-122">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-charcoal border-b border-brand-gold/20 overflow-hidden" data-id="element-123">
            <div className="flex flex-col items-center py-8 space-y-6" data-id="element-124">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-sm tracking-widest uppercase text-brand-offwhite hover:text-brand-gold transition-colors duration-300" data-id="element-125">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="px-8 py-3 border border-brand-gold text-brand-gold text-sm tracking-widest uppercase hover:bg-brand-gold hover:text-brand-black transition-colors duration-300 mt-4" data-id="element-126">
                Make a Reservation
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}